import { Box, Grid, Paper, Typography, Stack, Divider } from '@mui/material';

import StorageIcon from '@mui/icons-material/Storage';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import SecurityIcon from '@mui/icons-material/Security';
import BarChartIcon from '@mui/icons-material/BarChart';
import BuildIcon from '@mui/icons-material/Build';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import ImageFlow from 'assets/images/auth/homeimg.png';

function DiagramItem({ icon, title }) {
  return (
    <Paper
      elevation={2}
      sx={{
        p: 2,
        minWidth: 160,
        textAlign: 'center',
        borderRadius: 2
      }}
    >
      <Stack spacing={1} alignItems="center">
        {icon}
        <Typography fontWeight="bold">{title}</Typography>
      </Stack>
    </Paper>
  );
}

export default function HomePage() {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: '93vh',
        bgcolor: '#fff',
        borderRadius: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: 3
      }}
    >
      <Stack spacing={5} alignItems="center" width="100%">
        {/* TITLE */}
        <Typography variant="h4" fontWeight="bold">
          Welcome to DATAFORGE!
        </Typography>

        {/* FLOW IMAGE */}

        <Box
          component="img"
          src={ImageFlow}
          alt="DataForge Architecture Flow"
          sx={{
            maxWidth: '50%',
            height: 'auto',
            objectFit: 'contain'
          }}
        />

        {/* DESCRIPTION */}
        <Box>
          <Typography sx={{ textAlign: 'center' }} variant="h5" fontWeight="bold" gutterBottom>
            What is DataForge?
          </Typography>

          <Stack>
            <Typography color="text.secondary">
            DataForge is an Extract, Transform, and Load (ETL) tool with smart integrations for construction management. Here's an overview:
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Stack spacing={1} justifyContent={"center"}>
              <Typography>
                <strong>Extract:</strong> Data is pulled from various sources such as Autodesk Construction Cloud (ACC) and other databases.
              </Typography>
              <Typography>
                <strong>Transform:</strong> The data is cleaned, formatted, and altered to fit custom requirements.
              </Typography>
              <Typography>
                <strong>Load:</strong> Transformed data is loaded into a new system like a cloud platform or dashboard, making it accessible
                and ready for analysis.
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
}
